"use strict";

class ShopTheVideo {
  constructor() {
    this.player = null;
    this.slider = null;
    this.container = document.querySelector(".component__shop-video__content");
    this.video = document.querySelector("#shop-the-video");
    this.selectors = {
      shopVideoSlider: ".component__shop-video__content__slider",
      shopVideoSliderSlide: ".component__shop-video__content__slider__wrapper__slide",
      shopVideoSliderSlideActive: "component__shop-video__content__slider__wrapper__slide--active"
    };
    this.timePoints = [];
    this.started = false;
    this.onConsentChange = (isAllowed) => {
      if (isAllowed) this.startPlayer();
      else this.destroyPlayer();
    };
  }

  init() {
    if (!this.container || this.started) return;
    this.started = true;
    this.createSlider();
    this.createTimePoints();

    if (window.FBMPrivacyGate) {
      window.FBMPrivacyGate.onChange(this.onConsentChange);
      if (window.FBMPrivacyGate.allowed()) this.startPlayer();
    }
  }

  createSlider() {
    const sliderElement = this.container.querySelector(this.selectors.shopVideoSlider);
    if (!sliderElement || !window.Swiper || this.slider) return;

    this.slider = new Swiper(sliderElement, {
      slidesPerView: 1.6,
      centeredSlides: true,
      slideToClickedSlide: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
          slidesPerView: 3,
          centeredSlides: false,
          grabCursor: true,
          threshold: 32,
          navigation: {
            nextEl: ".component__shop-video__content__slider__next",
            prevEl: ".component__shop-video__content__slider__prev"
          }
        },
        1024: {
          spaceBetween: 16,
          slidesPerView: 4,
          centeredSlides: false,
          grabCursor: true,
          threshold: 32,
          navigation: {
            nextEl: ".component__shop-video__content__slider__next",
            prevEl: ".component__shop-video__content__slider__prev"
          }
        }
      }
    });
  }

  createTimePoints() {
    if (!this.container) return;
    this.timePoints = Array.from(
      this.container.querySelectorAll(`${this.selectors.shopVideoSliderSlide}[data-time]`)
    ).map((slide) => {
      const time = Math.round(Number.parseFloat(slide.dataset.time) * 4) / 4;
      slide.dataset.time = String(time);
      return { time, index: Number.parseInt(slide.dataset.slideIndex, 10), slide };
    }).filter((point) => Number.isFinite(point.time) && Number.isFinite(point.index))
      .sort((left, right) => left.time - right.time);
  }

  startPlayer() {
    if (!this.video || this.player || !window.Plyr || !window.FBMPrivacyGate || !window.FBMPrivacyGate.allowed()) return;
    try {
      this.player = new Plyr(this.video);
      window.FBMPrivacyGate.registerPlayer(this.video, this.player, () => this.destroyPlayer());
      this.labelBufferedProgress = () => {
        const playerContainer = this.player && this.player.elements && this.player.elements.container;
        const buffer = playerContainer && playerContainer.querySelector(".plyr__progress__buffer");
        if (buffer && !buffer.getAttribute("aria-label")) buffer.setAttribute("aria-label", "Video buffered");
      };
      this.labelBufferedProgress();
      this.player.on("ready", this.labelBufferedProgress);
      this.player.on("timeupdate", (event) => this.updateTimeline(event.detail.plyr.currentTime));
      this.player.on("seeked", (event) => this.updateTimeline(event.detail.plyr.currentTime));
      this.player.on("ended", () => this.resetTimeline());
    } catch (error) {
      this.destroyPlayer();
    }
  }

  updateTimeline(currentTime) {
    if (!this.slider || !this.timePoints.length) return;
    const time = Math.round(currentTime * 4) / 4;
    let activePoint = null;
    this.timePoints.forEach((point) => {
      if (point.time <= time) activePoint = point;
    });
    if (!activePoint) {
      this.resetTimeline();
      return;
    }
    this.slider.slideTo(activePoint.index);
    this.timePoints.forEach((point) => {
      point.slide.classList.toggle(this.selectors.shopVideoSliderSlideActive, point === activePoint);
    });
  }

  resetTimeline() {
    if (this.slider) this.slider.slideTo(0);
    if (!this.container) return;
    this.container.querySelectorAll(`.${this.selectors.shopVideoSliderSlideActive}`).forEach((slide) => {
      slide.classList.remove(this.selectors.shopVideoSliderSlideActive);
    });
  }

  destroyPlayer() {
    if (!this.player) return;
    const player = this.player;
    this.player = null;
    try {
      player.destroy();
    } catch (error) {
      // Continue after cleanup errors so consent revocation can finish.
    }
  }
}

window.addEventListener("load", function () {
  const player = new ShopTheVideo();
  player.init();
});
